import React, { Component } from 'react';
import { View, ScrollView, KeyboardAvoidingView, Platform, Dimensions } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { size as _size, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import {
  VFScreen,
  VFText,
  PasswordInput,
  VFButton,
} from '@vfgroup-oneplatform/foundation/Components';
import SpinnerOverlay from '@vfgroup-oneplatform/foundation/Components/SpinnerOverlay';
import { withTheme, getThemeImages } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import FrameworkTestKeys from '../FrameworkTestKeys';

import styles from './ChangePassword.styles';
import { useNavigation } from '@react-navigation/native'
import { SuccessModal, FailureModal } from './Components';

const validationStatuses = Object.freeze({
  NOT_ENTERED: undefined,
  MATCHGING: true,
  NOT_MATCHING: false,
});

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.newPasswordValidationTimeOut = null;
    this.confirmPasswordValidationTimeOut = null;

    this.state = {
      currentPassword: '',
      newPassword: '',
      isNewPasswordValid: true,
      confirmNewPassword: '',
      isConfirmPasswordMatching: validationStatuses.NOT_ENTERED,
      isLoading: false,
      isPasswordChangeSuccess: false,
      error: null,
      isResultModalVisible: false,
      isTryAgainButtonPressed: false,
    };
  }

  onCurrentPasswordChange = text => {
    this.setState({
      currentPassword: text,
    });
  };

  onNewPasswordChange = text => {
    const { validateNewPassword } = this.props;
    this.setState(
      {
        newPassword: text,
      },
      () => {
        this.validateConfirmPassword();
        if (_size(text) > 0) {
          if (_isFunction(validateNewPassword)) {
            this.validateNewPassword();
          }
        } else {
          this.setState({ isNewPasswordValid: true });
        }
      },
    );
  };

  onConfirmNewPasswordChange = text => {
    this.setState(
      {
        confirmNewPassword: text,
      },
      () => {
        this.validateConfirmPassword();
      },
    );
  };

  onConfirmButtonPress = () => {
    const { onChangePasswordPress } = this.props;
    const { currentPassword, newPassword } = this.state;
    this.setState(
      {
        isLoading: true,
      },
      async () => {
        try {
          await onChangePasswordPress(currentPassword, newPassword);
          this.setState({
            isLoading: false,
            isPasswordChangeSuccess: true,
          });
        } catch (error) {
          this.setState({
            isLoading: false,
            isPasswordChangeSuccess: false,
            error: error,
          });
        }
      },
    );
  };

  onLoadingModalHide = () => {
    this.setState({
      isResultModalVisible: true,
    });
  };

  onFailureModalHide = () => {
    const { isTryAgainButtonPressed, currentPassword, newPassword, error } = this.state;
    const { onTryAgainPress } = this.props;

    if (isTryAgainButtonPressed) {
      this.setState(
        {
          isTryAgainButtonPressed: false,
        },
        () => {
          if (_isFunction(onTryAgainPress)) {
            onTryAgainPress(currentPassword, newPassword, error);
          } else {
            this.onConfirmButtonPress();
          }
        },
      );
    }
  };

  onModalButtonPress = () => {
    const { isPasswordChangeSuccess } = this.state;
    const { onSuccess } = this.props;

    if (isPasswordChangeSuccess) {
      this.setState(
        {
          isResultModalVisible: false,
        },
        () => {
          if (_isFunction(onSuccess)) {
            onSuccess();
          }
        },
      );
    } else {
      this.setState({
        isResultModalVisible: false,
        isTryAgainButtonPressed: true,
      });
    }
  };

  toggleModal = () => {
    const { isResultModalVisible } = this.state;
    this.setState({ isResultModalVisible: !isResultModalVisible });
  };

  validateNewPassword = () => {
    const { newPassword } = this.state;
    const { validateNewPassword } = this.props;
    if (this.newPasswordValidationTimeOut) {
      clearTimeout(this.newPasswordValidationTimeOut);
    }
    this.newPasswordValidationTimeOut = setTimeout(() => {
      if (validateNewPassword(newPassword)) {
        this.setState({
          isNewPasswordValid: true,
        });
      } else {
        this.setState({
          isNewPasswordValid: false,
        });
      }
    }, 800);
  };

  validateConfirmPassword = () => {
    const { newPassword, confirmNewPassword } = this.state;
    if (this.confirmPasswordValidationTimeOut) {
      clearTimeout(this.confirmPasswordValidationTimeOut);
    }
    if (_size(newPassword) > 0 && _size(confirmNewPassword) > 0) {
      this.confirmPasswordValidationTimeOut = setTimeout(() => {
        if (newPassword === confirmNewPassword) {
          this.setState({
            isConfirmPasswordMatching: validationStatuses.MATCHGING,
          });
        } else {
          this.setState({
            isConfirmPasswordMatching: validationStatuses.NOT_MATCHING,
          });
        }
      }, 800);
    } else if (_size(confirmNewPassword) <= 0) {
      this.setState({
        isConfirmPasswordMatching: validationStatuses.NOT_ENTERED,
      });
    } else {
      this.setState({
        isConfirmPasswordMatching: validationStatuses.NOT_MATCHING,
      });
    }
  };

  render() {
    const {
      onClosePress,
      changePasswordTitleStyle,
      changePasswordsubtitleStyle,
      newPasswordTitleStyle,
      invalidNewPasswordHelperText,
      theme,
      changePasswordErrorDescription,
      ...props
    } = this.props;

    const {
      currentPassword,
      newPassword,
      isNewPasswordValid,
      confirmNewPassword,
      isConfirmPasswordMatching,
      isLoading,
      isPasswordChangeSuccess,
      isResultModalVisible,
    } = this.state;

    const Images = getThemeImages(theme.name);

    let isConfirmNewPasswordValid;
    if (
      isConfirmPasswordMatching === validationStatuses.NOT_ENTERED ||
      isConfirmPasswordMatching === validationStatuses.MATCHGING
    ) {
      isConfirmNewPasswordValid = true;
    } else if (isConfirmPasswordMatching === validationStatuses.NOT_MATCHING) {
      isConfirmNewPasswordValid = false;
    }
    const isConfirmButtonDisabled =
      isConfirmPasswordMatching === validationStatuses.NOT_ENTERED ||
      isConfirmPasswordMatching === validationStatuses.NOT_MATCHING ||
      _size(currentPassword) === 0 ||
      _size(newPassword) === 0 ||
      _size(confirmNewPassword) === 0;

    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <VFScreen
          title={'change_password_title'}
          onClose={onClosePress}
          showBack={true}
          onBack={onClosePress}
          showClose={false}
          closeButtonTestID="CloseIcon"
          {...props}
        >
          <SpinnerOverlay
            isVisible={isLoading}
            autoPlay
            loop
            lottieStyle={styles.overlayLottie}
            onModalHide={this.onLoadingModalHide}
            type={LottieTypes.whiteSpinner}
          />
          <KeyboardAvoidingView
            behavior={'padding'}
            style={styles.keyboardAvoidingViewStyle}
          >
            <ScrollView
              showsVerticalScrollIndicator={false}
              style={styles.containerStyle}
            >
              <VFText
                i18nKey={'change_password_subtitle'}
                style={[
                  styles.changePasswordTitle(theme),
                  changePasswordTitleStyle
                ]}
                testID="ChangePasswordSubtitleID"
              />
              <VFText
                i18nKey={'change_password_description'}
                style={[
                  styles.changePasswordSubtitle(theme),
                  changePasswordsubtitleStyle
                ]}
                testID="ChangePasswordDescriptionID"
              />
              <View style={styles.mainCard(theme)}>
                <PasswordInput
                  testID="CurrentPasswordID"
                  label="change_password_current_password_placeholder"
                  value={currentPassword}
                  onChangeText={this.onCurrentPasswordChange}
                  selectionColor={theme.colors.textInput.default.selectionColor}
                  textColor={theme.colors.textColor}
                  containerStyle={styles.inputContainerStyle}
                  baseColor={theme.colors.textInput.default.baseColor}
                  tintColor={theme.colors.textInput.default.tintColor}
                />
                <VFText
                  i18nKey={'change_password_new_password_title'}
                  style={[styles.newPasswordTitle(theme), newPasswordTitleStyle]}
                />
                <PasswordInput
                  testID="NewPasswordID"
                  label="change_password_new_password_placeholder"
                  value={newPassword}
                  onChangeText={this.onNewPasswordChange}
                  baseColor={
                    isNewPasswordValid
                      ? theme.colors.textInput.default.baseColor
                      : theme.colors.textInput.error.baseColor
                  }
                  tintColor={
                    isNewPasswordValid
                      ? theme.colors.textInput.default.tintColor
                      : theme.colors.textInput.error.tintColor
                  }
                  selectionColor={theme.colors.textInput.default.selectionColor}
                  textColor={theme.colors.textColor}
                  containerStyle={styles.inputContainerStyle}
                  showHelperText={!isNewPasswordValid}
                  helperText={invalidNewPasswordHelperText}
                  helperTextColor={
                    !isNewPasswordValid
                      ? theme.colors.textInput.error.tintColor
                      : theme.colors.textInput.default.tintColor
                  }
                />
                <PasswordInput
                  testID="ConfirmPasswordID"
                  label="change_password_confirm_new_password_placeholder"
                  value={confirmNewPassword}
                  onChangeText={this.onConfirmNewPasswordChange}
                  baseColor={
                    isConfirmNewPasswordValid
                      ? theme.colors.textInput.default.baseColor
                      : theme.colors.textInput.error.baseColor
                  }
                  tintColor={
                    isConfirmNewPasswordValid
                      ? theme.colors.textInput.default.tintColor
                      : theme.colors.textInput.error.tintColor
                  }
                  selectionColor={theme.colors.textInput.default.selectionColor}
                  textColor={theme.colors.textColor}
                  containerStyle={[
                    styles.inputContainerStyle,
                    styles.confirmNewPassword
                  ]}
                  showHelperText={!isConfirmNewPasswordValid}
                  helperText={
                    'change_password_confirm_new_password_error_message'
                  }
                  helperTextColor={
                    !isConfirmNewPasswordValid
                      ? theme.colors.textInput.error.tintColor
                      : theme.colors.textInput.default.tintColor
                  }
                />
                <View style={styles.sectionSeparator(theme)} />
                <VFButton
                  title={'change_password_confirm_button_title'}
                  disabled={isConfirmButtonDisabled}
                  onPress={this.onConfirmButtonPress}
                  disabledStyle={styles.confirmButton(theme)}
                  disabledTextStyle={styles.confirmButtonText(theme)}
                  textAccessibilityLabel="ConfirmButton"
                />
              </View>
            </ScrollView>
          </KeyboardAvoidingView>
          {isPasswordChangeSuccess ? (
            <SuccessModal
              isVisible={isResultModalVisible}
              title={'change_password_modal_title'}
              modalType={'secondary'}
              toggleModal={this.toggleModal}
              withCloseButton={!isPasswordChangeSuccess}
              lottieType={LottieTypes.tick}
              message={'change_password_modal_success_title'}
              description={'change_password_modal_success_subtitle'}
              buttonText={'change_password_modal_success_button_title'}
              onButtonPress={this.onModalButtonPress}
            />
          ) : (
            <FailureModal
              isVisible={isResultModalVisible}
              title={'change_password_modal_title'}
              modalType={'secondary'}
              toggleModal={this.toggleModal}
              withCloseButton={!isPasswordChangeSuccess}
              image={Images.ic_WarningHiLight_Theme}
              message={'change_password_modal_failure_title'}
              description={changePasswordErrorDescription}
              buttonText={'change_password_modal_failure_button_title'}
              onButtonPress={this.onModalButtonPress}
              onModalHide={this.onFailureModalHide}
              backdropTransitionOutTiming={0} // fix bug of screen flicker on close modal
              mainViewAccessibilityLabel="FailureModalAccessibilityLabel"
              quickActionMenuCloseIconTestID="CloseIconTestID"
              theme={theme}
            />
          )}
        </VFScreen>
      )
    }


    return (
      <VFScreen
        title={'change_password_title'}
        onClose={onClosePress}
        closeButtonTestID={FrameworkTestKeys.ChangePasswordCloseIcon}
      >
        <SpinnerOverlay
          isVisible={isLoading}
          autoPlay
          loop
          lottieStyle={styles.overlayLottie}
          onModalHide={this.onLoadingModalHide}
          type={LottieTypes.whiteSpinner}
        />
        <KeyboardAvoidingView behavior={'padding'} style={styles.keyboardAvoidingViewStyle}>
          <ScrollView showsVerticalScrollIndicator={false} style={styles.containerStyle}>
            <VFText
              i18nKey={'change_password_subtitle'}
              style={[styles.changePasswordTitle(theme), changePasswordTitleStyle]}
              testID={FrameworkTestKeys.ChangePasswordSubtitleID}
            />
            <VFText
              i18nKey={'change_password_description'}
              style={[styles.changePasswordSubtitle(theme), changePasswordsubtitleStyle]}
              testID={FrameworkTestKeys.ChangePasswordDescriptionID}
            />
            <View style={styles.mainCard(theme)}>
              <PasswordInput
                testID={FrameworkTestKeys.CurrentPasswordID}
                label="change_password_current_password_placeholder"
                value={currentPassword}
                onChangeText={this.onCurrentPasswordChange}
                selectionColor={theme.colors.textInput.default.selectionColor}
                textColor={theme.colors.textColor}
                containerStyle={styles.inputContainerStyle}
                baseColor={theme.colors.textInput.default.baseColor}
                tintColor={theme.colors.textInput.default.tintColor}
              />
              <VFText
                i18nKey={'change_password_new_password_title'}
                style={[styles.newPasswordTitle(theme), newPasswordTitleStyle]}
              />
              <PasswordInput
                testID={FrameworkTestKeys.NewPasswordID}
                label="change_password_new_password_placeholder"
                value={newPassword}
                onChangeText={this.onNewPasswordChange}
                baseColor={
                  isNewPasswordValid
                    ? theme.colors.textInput.default.baseColor
                    : theme.colors.textInput.error.baseColor
                }
                tintColor={
                  isNewPasswordValid
                    ? theme.colors.textInput.default.tintColor
                    : theme.colors.textInput.error.tintColor
                }
                selectionColor={theme.colors.textInput.default.selectionColor}
                textColor={theme.colors.textColor}
                containerStyle={styles.inputContainerStyle}
                showHelperText={!isNewPasswordValid}
                helperText={invalidNewPasswordHelperText}
                helperTextColor={
                  !isNewPasswordValid
                    ? theme.colors.textInput.error.tintColor
                    : theme.colors.textInput.default.tintColor
                }
              />
              <PasswordInput
                testID={FrameworkTestKeys.ConfirmPasswordID}
                label="change_password_confirm_new_password_placeholder"
                value={confirmNewPassword}
                onChangeText={this.onConfirmNewPasswordChange}
                baseColor={
                  isConfirmNewPasswordValid
                    ? theme.colors.textInput.default.baseColor
                    : theme.colors.textInput.error.baseColor
                }
                tintColor={
                  isConfirmNewPasswordValid
                    ? theme.colors.textInput.default.tintColor
                    : theme.colors.textInput.error.tintColor
                }
                selectionColor={theme.colors.textInput.default.selectionColor}
                textColor={theme.colors.textColor}
                containerStyle={[styles.inputContainerStyle, styles.confirmNewPassword]}
                showHelperText={!isConfirmNewPasswordValid}
                helperText={'change_password_confirm_new_password_error_message'}
                helperTextColor={
                  !isConfirmNewPasswordValid
                    ? theme.colors.textInput.error.tintColor
                    : theme.colors.textInput.default.tintColor
                }
              />
              <View style={styles.sectionSeparator(theme)} />
              <VFButton
                title={'change_password_confirm_button_title'}
                disabled={isConfirmButtonDisabled}
                onPress={this.onConfirmButtonPress}
                disabledStyle={styles.confirmButton(theme)}
                disabledTextStyle={styles.confirmButtonText(theme)}
                testKey={FrameworkTestKeys.ConfirmButton}
              />
            </View>
          </ScrollView>
        </KeyboardAvoidingView>
        {isPasswordChangeSuccess ? (
          <SuccessModal
            isVisible={isResultModalVisible}
            title={'change_password_modal_title'}
            modalType={'secondary'}
            toggleModal={this.toggleModal}
            withCloseButton={!isPasswordChangeSuccess}
            lottieType={LottieTypes.tick}
            message={'change_password_modal_success_title'}
            description={'change_password_modal_success_subtitle'}
            buttonText={'change_password_modal_success_button_title'}
            onButtonPress={this.onModalButtonPress}
          />
        ) : (
          <FailureModal
            isVisible={isResultModalVisible}
            title={'change_password_modal_title'}
            modalType={'secondary'}
            toggleModal={this.toggleModal}
            withCloseButton={!isPasswordChangeSuccess}
            image={Images.ic_WarningHiLight_Theme}
            message={'change_password_modal_failure_title'}
            description={changePasswordErrorDescription}
            buttonText={'change_password_modal_failure_button_title'}
            onButtonPress={this.onModalButtonPress}
            onModalHide={this.onFailureModalHide}
            backdropTransitionOutTiming={0} // fix bug of screen flicker on close modal
            mainViewAccessibilityLabel={FrameworkTestKeys.FailureModal}
            quickActionMenuCloseIconTestID={FrameworkTestKeys.CloseIcon}
            theme={theme}
          />
        )}
      </VFScreen>
    );
  }
}
ChangePassword.defaultProps = {
  changePasswordErrorDescription: 'change_password_modal_failure_subtitle',
};
ChangePassword.propTypes = {
  onClosePress: PropTypes.func,
  changePasswordTitleStyle: ViewPropTypes.style,
  changePasswordsubtitleStyle: ViewPropTypes.style,
  newPasswordTitleStyle: ViewPropTypes.style,
  onChangePasswordPress: PropTypes.func,
  validateNewPassword: PropTypes.func,
  invalidNewPasswordHelperText: PropTypes.string,
  onSuccess: PropTypes.func,
  onTryAgainPress: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  changePasswordErrorDescription: PropTypes.string,
};

export default withTheme(ChangePassword);
